import {
  electronicFormat as electronicFormatIBAN,
  isValid as isValidIBAN,
  printFormat as formatIBAN,
} from 'iban';

export const ibanUtils = {
  mask: (input: string) => {
    return isValidIBAN(input) ? formatIBAN(input) : input;
  },

  unmask: (input: string) => {
    return isValidIBAN(input) ? electronicFormatIBAN(input) : input;
  },
};
